module.exports = __webpack_public_path__ + "img/zb-nodata.37ed1f54.png";